import moment from 'moment-timezone';

export const getDefaultTime = () => {
  const nextDay = moment().add(1, 'day').hour(8).minute(0).second(0).millisecond(0);
  return nextDay;
};
